import { E_CORE_ACTION_TYPES } from './actionTypes';
import { actionCreator } from '../helpers/actionCreator';
export var coreActions = {
    resetConf: function () { return actionCreator(E_CORE_ACTION_TYPES.RESET_CONF); },
    updateUrlConfRequested: function (urlConfigs) { return actionCreator(E_CORE_ACTION_TYPES.UPDATE_URL_CONF_REQUESTED, { urlConfigs: urlConfigs }); },
    updateUrlConfSucceeded: function (urlConfigs) { return actionCreator(E_CORE_ACTION_TYPES.UPDATE_URL_CONF_SUCCEEDED, { urlConfigs: urlConfigs }); },
    updateRealmRequested: function (realm) { return actionCreator(E_CORE_ACTION_TYPES.UPDATE_REALM_REQUESTED, { realm: realm }); },
    fetchConfRequested: function () { return actionCreator(E_CORE_ACTION_TYPES.FETCH_CONF_REQUESTED); },
    fetchConfSucceeded: function (configs) { return actionCreator(E_CORE_ACTION_TYPES.FETCH_CONF_SUCCEEDED, { configs: configs }); },
    removeNotificationRequested: function (notification) {
        return actionCreator(E_CORE_ACTION_TYPES.REMOVE_NOTIFICATION_REQUESTED, { notification: notification });
    },
    removeNotificationSucceeded: function (notifications) {
        return actionCreator(E_CORE_ACTION_TYPES.REMOVE_NOTIFICATION_SUCCEEDED, { notifications: notifications });
    },
    addNotificationRequested: function (notification) {
        return actionCreator(E_CORE_ACTION_TYPES.ADD_NOTIFICATION_REQUESTED, { notification: notification });
    },
    addNotificationSucceeded: function (notifications) {
        return actionCreator(E_CORE_ACTION_TYPES.ADD_NOTIFICATION_SUCCEEDED, { notifications: notifications });
    },
    addFilesUrlsRequested: function (filesUrls, toParse) {
        return actionCreator(E_CORE_ACTION_TYPES.ADD_FILE_URLS_REQUESTED, { filesUrls: filesUrls, toParse: toParse });
    },
    addFilesUrlsSucceeded: function (filesUrls) { return actionCreator(E_CORE_ACTION_TYPES.ADD_FILE_URLS_SUCCEEDED, { filesUrls: filesUrls }); },
    addFilesUrlsCancelled: function () { return actionCreator(E_CORE_ACTION_TYPES.ADD_FILE_URLS_CANCELLED); },
    updateLocale: function (locale) { return actionCreator(E_CORE_ACTION_TYPES.UPDATE_LOCALE, { locale: locale }); },
    pingApiRequested: function () { return actionCreator(E_CORE_ACTION_TYPES.PING_API_REQUESTED); },
    pingApiSucceeded: function (apisStatus) { return actionCreator(E_CORE_ACTION_TYPES.PING_API_SUCCEEDED, { apisStatus: apisStatus }); },
    updateFileUrlSource: function (url, sources, sourceIndex) {
        return actionCreator(E_CORE_ACTION_TYPES.UPDATE_FILE_URL_SOURCE, { url: url, sources: sources, sourceIndex: sourceIndex });
    },
};
